var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPost(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22134_57945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2973 2.11504C11.6888 1.72353 11.8845 1.52777 12.1014 1.43416C12.4138 1.29929 12.7681 1.29929 13.0805 1.43416C13.2974 1.52777 13.4931 1.72353 13.8846 2.11504C14.2761 2.50655 14.4719 2.70231 14.5655 2.91917C14.7004 3.23161 14.7004 3.58584 14.5655 3.89827C14.4719 4.11513 14.2761 4.31089 13.8846 4.7024L10.5369 8.05013C9.71211 8.87492 9.29972 9.28732 8.7832 9.53167C8.26668 9.77602 7.68629 9.83329 6.52549 9.94782L6 9.99968L6.05185 9.47419C6.16639 8.31339 6.22366 7.73299 6.46801 7.21647C6.71236 6.69996 7.12475 6.28756 7.94955 5.46277L11.2973 2.11504Z",
    stroke: "#242428",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00016 10H2.50016C1.85583 10 1.3335 10.5223 1.3335 11.1667C1.3335 11.811 1.85583 12.3333 2.50016 12.3333L8.8335 12.3333C9.47783 12.3333 10.0002 12.8557 10.0002 13.5C10.0002 14.1443 9.47783 14.6667 8.8335 14.6667H7.3335",
    stroke: "#242428",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22134_57945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPost);
export default __webpack_public_path__ + "static/media/icon-post.f4c08790b93b43482f39c75b9e47273c.svg";
export { ForwardRef as ReactComponent };